import React from "react";
import { useLanguage } from "@/context/LanguageContext";
import { indexLabels } from "@/i18n";

const SellerBenefits = () => {
  const { language } = useLanguage();
  const labels = indexLabels(language);

  return (
    <div className="flex-1">
      <div className="relative overflow-hidden rounded-2xl p-6 md:p-8 h-full border border-white/20 shadow-xl transition-all duration-150 hover:shadow-2xl hover:border-emerald-400/30 bg-gradient-to-br from-emerald-700 via-teal-600 to-emerald-800"
      >
        <div
          className="absolute inset-0 pointer-events-none opacity-20"
          style={{
            background: "radial-gradient(ellipse 120% 80% at 50% -5%, rgba(16,185,129,0.4), transparent 70%)",
          }}
        />
        <h3 className="relative text-xl md:text-2xl font-bold mb-3 md:mb-4 text-center text-white">
          {labels.sellerBenefits.title}
        </h3>
        <div className="relative grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-4 text-left text-xs md:text-sm">
          <ul className="space-y-2">
            <li className="flex items-center text-white/90">
              <div className="w-1.5 h-1.5 bg-emerald-400/80 rounded-full mr-2 flex-shrink-0" />
              {labels.sellerBenefits.item1}
            </li>
            <li className="flex items-center text-white/90">
              <div className="w-1.5 h-1.5 bg-emerald-400/80 rounded-full mr-2 flex-shrink-0" />
              {labels.sellerBenefits.item2}
            </li>
            <li className="flex items-center text-white/90">
              <div className="w-1.5 h-1.5 bg-emerald-400/80 rounded-full mr-2 flex-shrink-0" />
              {labels.sellerBenefits.item3}
            </li>
          </ul>
          <ul className="space-y-2">
            <li className="flex items-center text-white/90">
              <div className="w-1.5 h-1.5 bg-emerald-400/80 rounded-full mr-2 flex-shrink-0" />
              {labels.sellerBenefits.item4}
            </li>
            <li className="flex items-center text-white/90">
              <div className="w-1.5 h-1.5 bg-emerald-400/80 rounded-full mr-2 flex-shrink-0" />
              {labels.sellerBenefits.item5}
            </li>
            <li className="flex items-center text-white/90">
              <div className="w-1.5 h-1.5 bg-emerald-400/80 rounded-full mr-2 flex-shrink-0" />
              {labels.sellerBenefits.item6}
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default SellerBenefits;
